export default function MarketsWeServe() {
  const markets = [
    {
      title: 'Multifamily and Affordable Housing',
      description: 'Ground-up construction and renovation of market-rate and affordable apartment communities throughout the United States, both urban and rural.',
      image: 'https://public.readdy.ai/ai/img_res/31fbdb96633dd5fcb14c9460a96fba66.jpg',
      expanding: false
    },
    {
      title: 'Commercial',
      description: 'Interior and exterior renovation of commercial properties for institutional investors and property managers pursuing value-add strategies.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20office%20building%20exterior%20showing%20modern%20architecture%20with%20clean%20lines%20and%20contemporary%20design.%20High-quality%20construction%20photography%20of%20multi-story%20commercial%20property%20with%20large%20windows%2C%20professional%20landscaping%2C%20and%20polished%20appearance.%20Bright%20daylight%20highlighting%20quality%20finishes%20and%20institutional-grade%20construction.%20Neutral%20color%20palette%20with%20emphasis%20on%20professional%20business%20environment%20and%20value-add%20renovation%20potential.&width=800&height=600&seq=commercial-property-renovation&orientation=landscape',
      expanding: false
    },
    {
      title: 'Senior Living and Healthcare',
      description: 'An expanding area of expertise bringing our proven multifamily renovation capabilities to memory care, nursing home, assisted living, and retirement community facilities.',
      image: 'https://readdy.ai/api/search-image?query=Warm%20welcoming%20senior%20living%20facility%20exterior%20with%20single%20or%20two-story%20residential-style%20architecture%20featuring%20covered%20entrance%2C%20accessible%20walkways%2C%20and%20mature%20landscaping.%20Professional%20photography%20showing%20comfortable%20homelike%20atmosphere%20with%20quality%20construction%2C%20large%20windows%2C%20and%20inviting%20design.%20Soft%20natural%20lighting%20emphasizing%20care%20and%20comfort.%20Neutral%20warm%20tones%20with%20emphasis%20on%20accessibility%20and%20resident-focused%20design%20for%20memory%20care%20and%20assisted%20living%20communities.&width=800&height=600&seq=senior-living-healthcare&orientation=landscape',
      expanding: true
    }
  ];

  return (
    <section className="py-20 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-[#C5A55A] mb-16 text-center">
          Markets We Serve
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {markets.map((market, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden relative">
              {market.expanding && (
                <div className="absolute top-4 right-4 bg-[#C5A55A] text-[#1A1A1A] px-3 py-1 rounded-full text-sm font-semibold z-10">
                  Expanding
                </div>
              )}
              <div className="h-64">
                <img
                  src={market.image}
                  alt={market.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1A1A1A] mb-4">
                  {market.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {market.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}